"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChimeAudioOutput = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _chime = require("@studio/chime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var ChimeAudioOutput = exports.ChimeAudioOutput = function ChimeAudioOutput(_ref) {
  var _ref$muted = _ref.muted,
    muted = _ref$muted === void 0 ? false : _ref$muted,
    meetingSession = _ref.meetingSession;
  var audioRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (meetingSession) {
      (0, _chime.bindAudioElement)(meetingSession, audioRef.current);
    }
  }, [meetingSession]);
  return /*#__PURE__*/_react["default"].createElement("audio", {
    ref: audioRef,
    muted: muted
  });
};
ChimeAudioOutput.propTypes = {
  muted: _propTypes["default"].bool,
  meetingSession: _propTypes["default"].object
};